module.exports = __webpack_public_path__ + "assets/img/detection-logo.b21fd0a4.svg";